/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { jsx } from '@emotion/core'
import { Post } from '../types'
import { StylesObject } from '../../../types/styles'
import { Divider } from './Divider'

interface LinkWithImageProps {
    styles: StylesObject
    post: Post
    index: number
    onLinkClick: (url: string, index: number) => void
    isSwimsuit: boolean
}

export const LinkWithImage: FunctionalComponent<LinkWithImageProps> = ({
    styles,
    post,
    index,
    onLinkClick,
    isSwimsuit,
}) => {
    const { image } = post
    return (
        <Fragment>
            <a
                key={post.id}
                onClick={() => onLinkClick(post.url, index)}
                css={styles.linkWithImage}
                href={post.url}
                target="_top"
            >
                <div css={styles.imageAndTitleWrapper}>
                    <div>{post.title}</div>
                    <img css={styles.image} src={image?.value?.url} alt={image?.value?.alt}></img>
                </div>
            </a>
            {!isSwimsuit && <Divider styles={styles} />}
        </Fragment>
    )
}
